/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and
 * international treaties. Unauthorized use, reproduction, distribution, or
 * modification of any content from Knowledge for Decisions (K4D) is strictly
 * prohibited. For inquiries regarding the use or licensing of K4D's
 * copyrighted materials, please contact us at contact@k4d.com.br. "Knowledge
 * for Decisions (K4D)" and the slogan "Using data to make precise decisions"
 * are registered trademarks of Knowledge for Decisions (K4D).
 */

import React from "react";
import { MarkdownContent, Loading } from "@/shared/ui";
import { useTranslation } from "react-i18next";
import PolicyPageLayout from "../service-terms/PolicyPageLayout";
import { useDocumentContent } from "../shared/hooks/useDocumentContent";
import { PageSEO, HreflangTags, BreadcrumbSchema } from "@/shared/seo";

const CookiePolicy: React.FC = () => {
  const { t } = useTranslation("@pages/policy");
  const { content, isLoading } = useDocumentContent('cookie-policy', `# ${t("cookiePolicy.title")}\n\nContent coming soon.`);

  if (isLoading) return <Loading mode="section" size="lg" />;

  return (
    <>
      {/* SEO Meta Tags */}
      <PageSEO
        title={t("cookiePolicy.title")}
        description={t("cookiePolicy.description", "Cookie Policy for Housien - Learn how we use cookies and similar technologies.")}
        noIndex={false}
      />
      <HreflangTags />
      <BreadcrumbSchema
        items={[
          { name: t("breadcrumb.home"), url: "/" },
          { name: t("cookiePolicy.title"), url: "/cookies/v1" },
        ]}
      />

      <PolicyPageLayout
        title={t("cookiePolicy.title")}
        lastUpdated={t("cookiePolicy.metaLastUpdated")}
        version={t("cookiePolicy.metaVersion")}
        lastUpdatedLabel={t("cookiePolicy.lastUpdated")}
        versionLabel={t("cookiePolicy.version")}
      >
        <MarkdownContent content={content} headingOffset={1} />
      </PolicyPageLayout>
    </>
  );
};

export default CookiePolicy;
